import {EnvUtils} from "../utils/env-utils";

export class PaypalConfig {
    public static clientId = EnvUtils.readString('REACT_APP_PAYPAL_CLIENT_ID');
}
